import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';

import { Spinner } from '../components/spinner';
import { appStore } from '../stores/app-store';
import { ToastProvider } from '../contexts/toast-context';

/**
 * The layout for authentication based pages. I.e. Login and Signup..
 * @returns
 */
const Authentication = observer(() => {
  return (
    <>
      <ToastProvider>
        <div className={'layout layout--authentication'}>
          <div className={'layout__left'}>
            <Outlet />
            {appStore.isLoading() && <Spinner />}
          </div>
          <div className={'layout__right'}>
            <img src="/cg-logo-stacked.svg" className="logo" />
          </div>
        </div>
      </ToastProvider>
    </>
  );
});

export default Authentication;
